﻿
import { Auth } from "./auth.js";
import { loadStoredSalesData } from "./orders_data.js";
/**
 * Efast Workbench - 业绩汇总 (个人月度统计)
 */
var _perfAllData = [];
var _perfCurrentMonth = "";

function loadPerformanceDashboard() {
    var container = document.getElementById("view-performance");
    if (!container) return;
    var isSuper = typeof Auth !== "undefined" && Auth.getRole && (Auth.getRole() === "boss" || Auth.getRole() === "supervisor");
    var myName = (typeof Auth !== "undefined" && Auth.getUser() ? Auth.getUser().displayName : "") || "";
    container.innerHTML = '<div style="padding:20px;"><h2 style="margin-bottom:16px;"><i class="fa-solid fa-chart-line"></i> ' + "我的业绩" + '</h2><div id="perf-loading" style="text-align:center;padding:30px;color:var(--text-muted);">加载中...</div></div>';

    fetch("/api/performance", { headers: { "Authorization": "Bearer " + (typeof Auth !== "undefined" && Auth.getToken ? Auth.getToken() : "") } })
        .then(function(r) { if (r.ok) return r.json(); return []; })
        .then(function(data) {
            if (!isSuper) { data = data.filter(function(o) { return o.owner === (typeof Auth !== "undefined" && Auth.getUser() ? Auth.getUser().username : ""); }); }
            _perfAllData = data;
            var now = new Date();
            _perfCurrentMonth = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0");
            if (data.length === 0) {
                document.getElementById("perf-loading").outerHTML = '<div style="text-align:center;padding:40px;color:var(--text-muted);">暂无纳入业绩的订单</div>';
                return;
            }
            renderPerfView();
        }).catch(function(e) {
            document.getElementById("perf-loading").innerHTML = '<span style="color:#ef4444;">加载失败: ' + e.message + '</span>';
        });
}

function parseAmount(amt) {
    if (!amt) return 0;
    return parseFloat(String(amt).replace(/[^0-9.]/g, "")) || 0;
}

function getMonthOrders(month) {
    return _perfAllData.filter(function(o) {
        if (!o.includedAt) return false;
        return o.includedAt.substring(0, 7) === month;
    });
}

function getMonthStats(month) {
    var orders = getMonthOrders(month);
    var total = orders.reduce(function(s, o) { return s + parseAmount(o.amount); }, 0);
    return { count: orders.length, total: total, orders: orders };
}

function getAllMonths() {
    var months = [];
    _perfAllData.forEach(function(o) {
        if (o.includedAt) {
            var m = o.includedAt.substring(0, 7);
            if (months.indexOf(m) === -1) months.push(m);
        }
    });
    months.sort();
    return months;
}

function goToMonth(m) { _perfCurrentMonth = m; renderPerfView(); }



function deletePerfOrder(orderId) {
    if (!confirm("确定从业绩中移除该订单？订单总览的已纳入徽章也会消失。")) return;
    fetch("/api/performance/" + orderId, {
        method: "DELETE",
        headers: {
          "Authorization": "Bearer " + (typeof Auth !== "undefined" && Auth.getToken ? Auth.getToken() : "")}
    }).then(function(r) { if (r.ok) return r.json(); throw new Error("fail"); })
    .then(function() {
        _perfAllData = _perfAllData.filter(function(o) { return o.id !== orderId; });
        if (window._performanceIds) {
            window._performanceIds = window._performanceIds.filter(function(id) { return id !== orderId; });
        }
        renderPerfView();
        if (typeof loadStoredSalesData === "function") loadStoredSalesData();
    }).catch(function(e) { console.error("删除失败:", e); });
}

function monthLabel(m) {
    var parts = m.split("-");
    return parseInt(parts[1]) + "月";
}

function changeMonth(delta) {
    var parts = _perfCurrentMonth.split("-");
    var y = parseInt(parts[0]), m = parseInt(parts[1]) + delta;
    if (m > 12) { y++; m = 1; }
    if (m < 1) { y--; m = 12; }
    _perfCurrentMonth = y + "-" + String(m).padStart(2, "0");
    renderPerfView();
}

function renderPerfView() {
    var container = document.getElementById("view-performance");
    if (!container) return;
    var isSuper = typeof Auth !== "undefined" && Auth.getRole && (Auth.getRole() === "boss" || Auth.getRole() === "supervisor");
    var myName = (typeof Auth !== "undefined" && Auth.getUser() ? Auth.getUser().displayName : "") || "";
    var stats = getMonthStats(_perfCurrentMonth);
    var allMonths = getAllMonths();

    var html = "";
    html += '<div style="display:flex;gap:16px;margin-bottom:20px;flex-wrap:wrap;">';
    html += '<div style="background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:16px 20px;flex:1;min-width:140px;"><div style="font-size:0.8rem;color:#64748b;">本月订单</div><div style="font-size:2rem;font-weight:bold;color:#16a34a;">' + stats.count + '</div></div>';
    html += '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:10px;padding:16px 20px;flex:1;min-width:140px;"><div style="font-size:0.8rem;color:#64748b;">本月成交额</div><div style="font-size:1.5rem;font-weight:bold;color:#2563eb;">$' + stats.total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</div></div>';
    html += '</div>';

    html += '<div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">';
    html += '<button onclick="changeMonth(-1)" style="background:#e2e8f0;border:none;border-radius:6px;padding:6px 14px;cursor:pointer;font-size:0.9rem;">◀</button>';
    html += '<span style="font-size:1.1rem;font-weight:bold;min-width:100px;text-align:center;">' + _perfCurrentMonth + '</span>';
    html += '<button onclick="changeMonth(1)" style="background:#e2e8f0;border:none;border-radius:6px;padding:6px 14px;cursor:pointer;font-size:0.9rem;">▶</button>';
    html += '</div>';

    if (stats.orders.length) {
        html += '<div class="table-responsive" style="margin-bottom:24px;"><table class="data-table"><thead><tr><th>订单号</th><th>客户</th><th>金额</th><th>纳入日</th><th>操作</th></tr></thead><tbody>';
        stats.orders.forEach(function(o) {
            var d = o.includedAt ? new Date(o.includedAt).toLocaleDateString("zh-CN") : "";
            html += '<tr><td><a href="https://biz.alibaba.com/order/detail.htm?orderId=' + o.id + '" target="_blank" style="color:#0284c7;">' + o.id + '</a></td><td><span data-buyer="' + (o.buyerName || '') + '">' + (o.buyerName || "") + '</span></td><td>' + (o.amount || "") + '</td><td>' + d + '</td><td><button onclick="deletePerfOrder(\'' + o.id + '\')" style="background:#ef4444;color:#fff;border:none;border-radius:4px;padding:2px 8px;cursor:pointer;font-size:0.75rem;">\u5220\u9664</button></td></tr>';
        });
        html += '</tbody></table></div>';
    } else {
        html += '<div style="text-align:center;padding:20px;color:var(--text-muted);margin-bottom:20px;">该月无纳入业绩的订单</div>';
    }

    if (allMonths.length > 1) {
        html += '<div style="border-top:1px solid #e2e8f0;padding-top:16px;"><div style="font-size:0.9rem;font-weight:bold;color:#64748b;margin-bottom:10px;">历史月份概览</div><div style="display:flex;gap:10px;flex-wrap:wrap;">';
        allMonths.forEach(function(m) {
            var s = getMonthStats(m);
            var isActive = m === _perfCurrentMonth;
            html += '<div onclick="goToMonth(' + JSON.stringify(m) + ')" style="cursor:pointer;background:' + (isActive ? '#ecfeff' : '#f8fafc') + ';border:1px solid ' + (isActive ? '#0891b2' : '#e2e8f0') + ';border-radius:8px;padding:10px 14px;min-width:90px;text-align:center;">';
            html += '<div style="font-weight:bold;font-size:0.9rem;">' + monthLabel(m) + '</div>';
            html += '<div style="font-size:0.75rem;color:#64748b;">' + s.count + '单</div>';
            html += '<div style="font-size:0.8rem;font-weight:bold;color:#2563eb;">$' + s.total.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '</div>';
            html += '</div>';
        });
        html += '</div></div>';
    }

    container.innerHTML = '<div style="padding:20px;"><h2 style="margin-bottom:16px;"><i class="fa-solid fa-chart-line"></i> ' + "我的业绩" + '</h2>' + html + '</div>';
}


window.changeMonth = changeMonth;
window.deletePerfOrder = deletePerfOrder;
window.goToMonth = goToMonth;
export { loadPerformanceDashboard };
